(() => {
  if (customElements.get('component-modal')) return;

  class ComponentModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-modal-dialog]');

      this.openEvents = this.eventList('openOn');
      this.closeEvents = this.eventList('closeOn');

      this.openEvents.forEach((name) => this.addEventListener(name, this.onOpenEvent));
      this.closeEvents.forEach((name) => this.addEventListener(name, this.onCloseEvent));
      this.dialog?.addEventListener('close', this.onClosed);
    }

    disconnectedCallback() {
      this.openEvents.forEach((name) => this.removeEventListener(name, this.onOpenEvent));
      this.closeEvents.forEach((name) => this.removeEventListener(name, this.onCloseEvent));
      this.dialog?.removeEventListener('close', this.onClosed);
    }

    eventList(datasetKey) {
      return (this.dataset[datasetKey] || '')
        .split(',')
        .map((name) => name.trim())
        .filter(Boolean);
    }

    onOpenEvent = (event) => {
      // A modal can scope its open trigger to one cart section: the notification
      // opens only when its own `cart-notification` target renders, not when some
      // other cart-target nested inside it (e.g. a cart-count) re-renders on an
      // update. Other modals leave this unset and match every open event.
      const requiredSection = this.dataset.openOnSection;
      if (requiredSection && event.detail?.section !== requiredSection) return;

      // Only when actually opening: remember what to return focus to on close
      // (the opening event can name a `trigger`, e.g. the add-to-cart button,
      // which native dialog focus-return misses because it was blurred during the
      // add). Guarding on `!open` also stops a later in-modal add — whose count
      // refresh re-fires this event — from overwriting the original trigger.
      if (this.dialog && !this.dialog.open) {
        this.returnFocus = event.detail?.trigger ?? null;
        this.dialog.showModal();
      }
    };

    onCloseEvent = () => {
      if (this.dialog?.open) this.dialog.close();
    };

    onClosed = () => {
      // Return focus to the explicit trigger (e.g. add-to-cart), or for a
      // command-opened modal, the button that opens it — re-queried so it works
      // even if that button was re-rendered while open (a variant change rebuilds
      // the picker, detaching the original invoker, so native focus-return would
      // fall to <body>).
      const invoker = this.dialog?.id
        ? document.querySelector(`[commandfor="${this.dialog.id}"]`)
        : null;

      let target = this.returnFocus || invoker;

      // If the target is hidden inside a now-closed dialog (e.g. the add-to-cart
      // button lived in the variant picker drawer, which closed when the item was
      // added), fall back to that dialog's own invoker.
      if (target?.checkVisibility && !target.checkVisibility()) {
        const dialog = target.closest('dialog');
        target = dialog?.id ? document.querySelector(`[commandfor="${dialog.id}"]`) : null;
      }

      target?.focus();
      this.returnFocus = null;
    };
  }

  customElements.define('component-modal', ComponentModal);
})();
